class DeliverySaverLandingController {
    constructor(settings, deliverySaverService, shopperService) {
        this.settings = settings;
        this.deliverySaverService = deliverySaverService;
        this.shopperService = shopperService;

        this.loading = true;
        this.freeTrialExtraContentEnabled = false;
    }

    $onInit() {
        this.deliverySaverService.verifyDeliverySaverIsAvailable();

        if (this.shopperService.IsGuest) {
            // TODO: Get isFreeTrialEligible from Setting
            const isFreeTrialEligible = true;
            this.init(null, isFreeTrialEligible);
        } else {
            this.deliverySaverService.getSubscription().then((response) => {
                this.init(response.Subscription, response.IsFreeTrialEligible);
            });
        }
    }

    init(subscription, isFreeTrialEligible) {
        this.subscription = subscription;
        this.freeTrialExtraContentEnabled = isFreeTrialEligible;

        const deliverySaverSettings = this.settings.deliverySaver;

        if (isFreeTrialEligible) {
            this.inclusionsHtml = deliverySaverSettings.freeTrialLandingInclusionsHtml;
            this.title = deliverySaverSettings.freeTrialLandingTitle;
        } else {
            this.inclusionsHtml = deliverySaverSettings.landingInclusionsHtml;
            this.title = deliverySaverSettings.landingTitle;
        }

        this.loading = false;
    }
}

DeliverySaverLandingController.$inject = ['Settings', 'DeliverySaverService', 'ShopperService'];

const DeliverySaverLandingComponentDefinition = {
    template: require('./delivery-saver-landing.component.html').trim(),
    controller: DeliverySaverLandingController,
};

module.exports = {
    DeliverySaverLandingComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/landing/delivery-saver-landing.component.js